import React from "react";

// components
import Navbar from "./navbar/Navbar";
import Footer from "./footer";
import { useLocation } from "react-router-dom";
import ChatWidget from "../../components/chat/ChatWidget";
import FloatingChat from "../../components/ui/FloatingChat/FloatingChat";

type IGuestTheme = {
  children: React.ReactNode;
};

const GuestTheme: React.FC<IGuestTheme> = ({ children }) => {
  const location = useLocation();
  const isHidden =
    location.pathname === "/login" || location.pathname === "/register";

  return (
    <div className="grid w-full">
      <Navbar isHidden={isHidden} />
      <section>{children}</section>
      <Footer isHidden={isHidden} />
      {!isHidden && <FloatingChat />}
      {!isHidden && <ChatWidget />}
    </div>
  );
};

export default GuestTheme;
